import type { ReactNode } from "react";
import { Button, Spinner } from "react-bootstrap";
import type { ApiError } from "../../../hooks/useApiResource";
import "../../epicLeaderboard/epicLeaderboard.css";
import "./pk.css";

type SectionProps = {
  id?: string;
  title: string;
  note?: ReactNode;
  // Previous content stays on screen, dimmed, while a new range loads.
  refetching?: boolean;
  children: ReactNode;
};

const PkSection = ({ id, title, note, refetching, children }: SectionProps) => (
  <section id={id} className="pk-section">
    <div className="d-flex align-items-center gap-3">
      <h3 className="pk-section-title">{title}</h3>
      {refetching && (
        <Spinner
          animation="border"
          variant="light"
          size="sm"
          className="mt-4 mb-3"
          role="status"
        >
          <span className="visually-hidden">Loading</span>
        </Spinner>
      )}
    </div>
    {note && <div className="player-muted-note mb-2">{note}</div>}
    <div className={refetching ? "is-refetching" : undefined}>{children}</div>
  </section>
);

export default PkSection;

type ErrorProps = {
  what: string;
  error?: ApiError | null;
  onRetry?: () => void;
};

export const PkError = ({ what, error, onRetry }: ErrorProps) => (
  <div className="pk-card text-center" role="alert">
    <div className="mb-2">
      Couldn't load {what}.
      {error && error.status >= 400 && error.status < 500 && (
        <div className="epic-lb-muted">{error.message}</div>
      )}
    </div>
    {onRetry && (
      <Button size="sm" variant="outline-light" onClick={onRetry}>
        Retry
      </Button>
    )}
  </div>
);

export const PkEmpty = ({ children }: { children: ReactNode }) => (
  <div className="pk-card text-center">{children}</div>
);
